import { AdjustmentType, RoundingMethod, RoundingType } from '@weareopenr/types';
import { IPriceBandFields } from 'src/types/priceRules';
import { formatPrice } from 'src/helpers/formatPrice/formatPrice';

export type TPriceRuleTitleStep = {
  title: string;
  subtitle: string;
};

export function getTitles(step: number, steps: TPriceRuleTitleStep[]) {
  const { title = '', subtitle = '' } = steps[step] ?? {};
  return [title, subtitle];
}

export const buildCalculationSubtitle = (calculation: IPriceBandFields['adjustment']) => {
  if (calculation.type === AdjustmentType.NONE) {
    return 'No calculation';
  }

  if (calculation.type === AdjustmentType.FIXED) {
    return `Adjust by fixed amount = ${formatPrice(Number(calculation.fixed))}`;
  } else {
    return `Adjust by percentage amount = ${Number(calculation.percentage)}%`;
  }
};

export const buildRoundingSubtitle = (rounding: IPriceBandFields['rounding']) => {
  if (rounding.type === RoundingType.NONE) {
    return 'No rounding';
  }

  const value = Number(rounding.value);
  if (isNaN(value)) {
    return 'Invalid rounding';
  }

  const str: string[] = [];
  switch (rounding.type) {
    case RoundingType.UP:
      str.push('Round up to');
      break;
    case RoundingType.DOWN:
      str.push('Round down to');
      break;
    case RoundingType.NEAREST:
      str.push('Round to nearest');
      break;
  }

  if (rounding.method === RoundingMethod.INTERVAL) {
    str.push('interval of');
  }

  str.push(formatPrice(value));
  return str.join(' ');
};
